import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import SearchesPanelFull from '../containers/SearchesPanelFull';
import SearchesPanelNarrow from '../containers/SearchesPanelNarrow';

const SearchesPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: SearchesPanelFull, narrow: SearchesPanelNarrow }}
  />
);

export default SearchesPanel;
